import { ParticipantDocumentTypeEnum } from './participant-document-type-enum.generated';

const x: { [index: string]: string } = {};
x[ParticipantDocumentTypeEnum.ConfirmationStatement] = 'Confirmation Statement';
x[ParticipantDocumentTypeEnum.EOI] = 'Evidence of Insurability';
x[ParticipantDocumentTypeEnum.DependentVerification] = 'Verification Documentation';
x[ParticipantDocumentTypeEnum.ProofOfLifeEvent] = 'Life Event Verification';
x[ParticipantDocumentTypeEnum.QMCSO] = 'QMCSO Court Order';
x[ParticipantDocumentTypeEnum.Miscellaneous] = 'Miscellaneous';
x[ParticipantDocumentTypeEnum.TaxForm] = 'Tax Form';
x[ParticipantDocumentTypeEnum.TotalCompensation] = 'Total Compensation';
export const ParticipantDocumentTypeEnumDescriptions: { [indexer: string]: string } = x;
